import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface AccountState {
  firstName: string;
  lastName: string;
  email: string;
  showWarningModal: boolean;
  personalInfoChanged: boolean;
  generalSettingsChanged: boolean;
  pendingNavigation: string | null;
}

const initialState: AccountState = {
  firstName: 'Name',
  lastName: 'Last Name',
  email: 'name.lastname@domain.com',
  showWarningModal: false,
  personalInfoChanged: false,
  generalSettingsChanged: false,
  pendingNavigation: null,
};

export const accountSlice = createSlice({
  name: 'account',
  initialState,
  reducers: {
    setName: (state, action: PayloadAction<string>) => {
      state.firstName = action.payload;
    },
    setLastName: (state, action: PayloadAction<string>) => {
      state.lastName = action.payload;
    },
    setEmail: (state, action: PayloadAction<string>) => {
      state.email = action.payload;
    },
    setShowWarningModal: (state, action: PayloadAction<boolean>) => {
      state.showWarningModal = action.payload;
    },
    setPersonalInfoChanged: (state, action: PayloadAction<boolean>) => {
      state.personalInfoChanged = action.payload;
    },
    setGeneralSettingsChanged: (state, action: PayloadAction<boolean>) => {
      state.generalSettingsChanged = action.payload;
    },
    setPendingNavigation: (state, action: PayloadAction<string | null>) => {
      state.pendingNavigation = action.payload;
    },
  },
});

export const {
  setName,
  setLastName,
  setEmail,
  setShowWarningModal,
  setPersonalInfoChanged,
  setGeneralSettingsChanged,
  setPendingNavigation,
} = accountSlice.actions;

export default accountSlice.reducer;
